import { AnalysisItem, GroupRowType, LegendItem, LocationItem } from "helpers/models";
import aggregationDetail from "report/common/aggregation-detail-event";

const groupData = (
  eventResult: AnalysisItem[],
  eventLegend: LegendItem,
  locationItems: LocationItem[],
  aggregationUnits: string[],
): GroupRowType[] => {
  const grouped = eventResult.reduce((acc, item) => {

    const key = item.valueLabel;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(item);
    return acc;
  }, {} as { [key: string]: AnalysisItem[] });

  const groupDetail = aggregationDetail(
    grouped,
    locationItems,
    eventLegend,
    aggregationUnits
  );
  return groupDetail;
};

export default groupData;
